
import axios from "axios";
import React, { createContext, useContext, useState } from "react";

const MentionContext = createContext();

export const MentionProvider = ({ children }) => {
  const [suggestions, setSuggestions] = useState([]);
  const [mentions, setMentions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [activeText, setActiveText] = useState("");
  const [activeSetter, setActiveSetter] = useState(null);
  const [activeInputEl, setActiveInputEl] = useState(null);
  const [dropdownPos, setDropdownPos] = useState({
    top: 0,
    left: 0,
    width: 260,
  });
  const closeDropdown = () => {
    setShowDropdown(false);
    setSuggestions([]);
  };
  
  const fetchSuggestions = async (search) => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(
        `${process.env.REACT_APP_API_HOST_URL}/ops/v1/tags/taggable`,
        {
          params: { search },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSuggestions(res.data.data);
      setShowDropdown(true);
    } catch (error) {
      console.error("Error fetching mention suggestions:", error);
      setShowDropdown(false);
    }
  };

  // register active input
  const registerInput = (text, setter, inputEl) => {
    setActiveText(text);
    setActiveSetter(() => setter);
    setActiveInputEl(inputEl);  
  
    const rect = inputEl.getBoundingClientRect();
  
    setDropdownPos({
      top: rect.bottom + window.scrollY,
      left: rect.left + window.scrollX,
      width: rect.width,
    });
  };
  

  const addMention = (user) => {
    if (!activeSetter || typeof activeText !== "string") return;
  
    const name = user.username || user.name;
    const updatedText = activeText.replace(/@\w*$/, `@${name} `);
    
    activeSetter(updatedText);
  
    
    setMentions((prev) => {
      if (prev.find((u) => u._id === user._id)) return prev;
  
      return [
        ...prev,
        {
          _id: user._id,
          username: name, 
        },
      ];
    });
  
    setShowDropdown(false);
  };
  

  const resetMentions = () => {
    setMentions([]);
    setShowDropdown(false);
  };

  return (
    <MentionContext.Provider
      value={{
        suggestions,
        mentions,
        showDropdown,
        fetchSuggestions,
        addMention,
        registerInput,
        resetMentions,
        dropdownPos,
        setActiveText,
        closeDropdown
      }}
    >
      {children}
    </MentionContext.Provider>
  );
};

export const useMention = () => useContext(MentionContext);
